import { type GraphQLError } from 'graphql'
import { type GraphQLOptions } from '@aws-amplify/api-graphql'
import { API } from 'aws-amplify'

enum ErrorType {
  UNAUTHORIZED = 'Unauthorized',
  UNKNOWN = 'Unknown',
}

export interface Pagination {
  nextToken?: string
  limit?: number
}

export interface PaginationBasedQuery<Data> {
  items: Data[]
  nextToken?: string
}

type AppSyncGraphQLError = {
  errorType?: ErrorType
} & GraphQLError

interface APIGraphQLErrorRequestInput {
  query: string
  variables: any
}

export class APIGraphQLError extends Error {
  private readonly graphqlErrors: AppSyncGraphQLError[]
  public readonly request: APIGraphQLErrorRequestInput

  public readonly errorType: ErrorType

  constructor (error: any, request: APIGraphQLErrorRequestInput, message?: string) {
    super((message != null) || error.errors.map((e: any) => e.message).join(', '))
    this.graphqlErrors = error.errors
    console.log(this.graphqlErrors)
    this.name = 'APIGraphQLError'
    this.request = request
    this.errorType = APIGraphQLError.getErrorType(this.graphqlErrors)
  }

  private static getErrorType (graphqlErrors: AppSyncGraphQLError[]): ErrorType {
    if (graphqlErrors[0].errorType) {
      return graphqlErrors[0].errorType
    }

    return ErrorType.UNKNOWN
  }

  static isAPIGraphQLError (error: any): boolean {
    if (error instanceof APIGraphQLError) {
      return true
    }

    // eslint-disable-next-line no-prototype-builtins
    if ((Boolean(error.hasOwnProperty('errors'))) && (Boolean(error.hasOwnProperty('data')))) {
      return true
    }

    if (error instanceof Error && error.message === 'No current user') {
      return true
    }

    return false
  }
}

type APIRequestGraphQLOptions = {
  publicQuery?: boolean
} & GraphQLOptions

// Return type not exported by aws-amplify

export async function GraphQLRequest<T> (options: APIRequestGraphQLOptions): Promise<any> {
  try {
    console.log('GraphQLRequest')
    const result = await API.graphql<T>({
      authMode: (options.publicQuery === true) ? 'AWS_IAM' : 'AMAZON_COGNITO_USER_POOLS',
      ...options
    })
    return result
  } catch (error) {
    console.log(error)
    console.log(options.query, options.variables)
    if (APIGraphQLError.isAPIGraphQLError(error)) {
      throw new APIGraphQLError(error, {
        query: options.query as string,
        variables: options.variables
      })
    }
    throw error
  }
}
